export default class DataService {
    static getDataPromise() {
        return new Promise((resolve, reject) => {
            fetch("https://terem.mik.pte.hu/get-timetable")
                .then(res => {
                if (res.status === 200) {
                    res.json()
                        .then(json => {
                        try {
                            if (localStorage.getItem("hash") === json.hash &&
                                localStorage.getItem("data") &&
                                localStorage.getItem("data") !== null &&
                                localStorage.getItem("start")) {
                                resolve(JSON.parse(localStorage.getItem("data")));
                            }
                            else {
                                throw new Error("No local storage match found! Reloading data.");
                            }
                        }
                        catch (Error) {
                            localStorage.setItem("start", json.start);
                            localStorage.setItem("hash", json.hash);
                            localStorage.setItem("data", null);
                            fetch('https://terem.mik.pte.hu' + json.url).then(res => {
                                if (res.status === 200) {
                                    res.json().then(json => {
                                        localStorage.setItem("data", JSON.stringify(json));
                                        resolve(JSON.parse(localStorage.getItem("data")));
                                    });
                                }
                            });
                        }
                    });
                }
            });
        });
    }
}
